<template>
   <LoginDetail />
</template>

<script>
import LoginDetail from "@/esf_antarctica_lederhosenland/core/components/authentication/login/LoginDetail.vue"
export default {
  name: "Login",
  components: {
  LoginDetail
  },
  
};
</script>

